// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48367270","453":"3cc1e01a","455":"3603736e","977":"82122409"}[chunkId] + ".chunk.js";
};